export default __webpack_public_path__ + "static/media/red-down-arrow.f83d5af0.svg";